// extracted by mini-css-extract-plugin
module.exports = {"bestPropertyTag":"styles_bestPropertyTag__XCG_5 system_captionL__sBgtx","branded":"styles_branded__X2P14"};